import { atom } from 'nanostores'

export const $isCloseButtonVisible = atom(false)

export const closeButton = {
  show: () => $isCloseButtonVisible.set(true),
  hide: () => $isCloseButtonVisible.set(false),
}
